import React from "react";
import { Navigate } from "react-router-dom";
import { Box, Card, CardContent, Button, Typography } from "@mui/material";
import { useAuth } from "../context/AuthContext";

export default function LoginForm() {
  const { isAuthenticated, login } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }

  return (
    <Box sx={{ maxWidth: 400, mx: "auto", mt: 8 }}>
      <Card elevation={3} sx={{ borderRadius: 2 }}>
        <Box sx={{ bgcolor: "primary.main", color: "white", p: 2 }}>
          <Typography variant="h5" align="center">
            Login
          </Typography>
        </Box>
        <CardContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <Typography variant="body1" align="center" color="text.secondary">
            Sign in with your organization account
          </Typography>
          <Button variant="contained" fullWidth size="large" onClick={login}>
            Sign in
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
